import * as THREE from 'three'
import Experience from '../Experience'

export default class Field {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug
    //Options
    this.resource = this.resources.items.field

    //Methods
    this.setMaterial()
    this.setModel()
  }
  setMaterial() {
    //field
    this.fieldTexture = this.resources.items.fieldTexture
    this.fieldTexture.flipY = false
    this.fieldTexture.encoding = THREE.sRGBEncoding
    this.fieldMaterial = new THREE.MeshBasicMaterial({ map: this.fieldTexture })

    //logo
    this.logoTexture = this.resources.items.logoField
    this.logoTexture.flipY = false
    this.logoTexture.encoding = THREE.sRGBEncoding
    this.logoMaterial = new THREE.MeshBasicMaterial({ map: this.logoTexture, transparent: true })
    //launay
    this.launayTexture = this.resources.items.launay
    this.launayTexture.flipY = false
    this.launayTexture.encoding = THREE.sRGBEncoding
    this.launayMaterial = new THREE.MeshBasicMaterial({ map: this.launayTexture })

    //ouestFrance
    this.ouestFranceTexture = this.resources.items.ouestFrance
    this.ouestFranceTexture.flipY = false
    this.ouestFranceTexture.encoding = THREE.sRGBEncoding
    this.ouestFranceMaterial = new THREE.MeshBasicMaterial({ map: this.ouestFranceTexture })

    //delarte
    this.delarteTexture = this.resources.items.delarte
    this.delarteTexture.flipY = false
    this.delarteTexture.encoding = THREE.sRGBEncoding
    this.delarteMaterial = new THREE.MeshBasicMaterial({ map: this.delarteTexture })

    //samsic
    this.samsicTexture = this.resources.items.samsic
    this.samsicTexture.flipY = false
    this.samsicTexture.encoding = THREE.sRGBEncoding
    this.samsicMaterial = new THREE.MeshBasicMaterial({ map: this.samsicTexture })
  }
  setModel() {
    this.model = this.resource.scene

    //logo
    const logo = this.model.children.find(child => child.name === 'logo')
    logo.material = this.logoMaterial

    //field
    const field = this.model.children.find(child => child.name === 'field')
    field.material = this.fieldMaterial

    //launay
    const launay = this.model.children.find(child => child.name === 'launay')
    launay.material = this.launayMaterial

    //ouestFrance
    const ouestFrance = this.model.children.find(child => child.name === 'ouestFrance')
    ouestFrance.material = this.ouestFranceMaterial

    //delarte
    const delarte = this.model.children.find(child => child.name === 'delarte')
    delarte.material = this.delarteMaterial

    //samsic
    const samsic = this.model.children.find(child => child.name === 'samsic')
    samsic.material = this.samsicMaterial

    this.model.scale.set(0.4, 0.4, 0.4)
    this.scene.add(this.model)
  }
}
